<ddj-spinner *ngIf="isLoading"></ddj-spinner>
<section>
    <div class="form-wrap">
        <form [formGroup]="resetPasswordForm" (ngSubmit)="resetPasswordSubmit()">
            <h2>Please enter the email associated with this account for verification purposes.</h2>
            <mat-form-field style="width: 100%" appearance="fill">
                <mat-label>Email</mat-label>
                <input matInput formControlName="email" data-test="reset-password-email" />
                <mat-error>{{ fieldError(resetPasswordForm, 'email') }}</mat-error>
            </mat-form-field>

            <h3>How would you like to receive the password reset token?</h3>
            <mat-radio-group class="notification-type" aria-label="Select an option for notification" formControlName="isPhone">
                <mat-radio-button class="select-notification" [value]="false">Email</mat-radio-button>
                <mat-radio-button class="select-notification" [value]="true">Mobile Phone</mat-radio-button>
            </mat-radio-group>
            <div>
                <button style="width: 100%" class="mt-2" mat-flat-button type="submit" color="secondary">Submit</button>
            </div>
            <div class="mt-4 mb-5 links">
                <a routerLink="/login" style="color: var(--tenant-header)">Log In</a>
            </div>
        </form>
    </div>
</section>
